<template>
    <PageLoading v-if="isLoading" />
    <div v-else class="main-wrap about-page">
        <div class="history">
            <div class="row">
                <div class="col-12 col-md-6">
                    <div class="text-wrap">
                        <h2>{{ history.title }}</h2>
                        <h4>{{ history.subtitle }}</h4>
                        <span v-html="history.first_content"></span>
                    </div>
                </div>
                <div class="history-img-right col-12 col-md-6">
                    <img :src="firstImage" alt="CFMA" />
                </div>
            </div>
            <div class="row">
                <div class="history-img-left col-12 col-md-6">
                    <img :src="secondImage" alt="CFMA" />
                </div>
                <div class="col-12 col-md-6">
                    <div class="text-wrap">
                        <span v-html="history.second_content"></span>
                    </div>
                </div>
            </div>
        </div>
        <div class="timeline text-center">
            <h2>{{ history.timeline_title }}</h2>
            <q-timeline layout="loose" color="secondary">
                <q-timeline-entry
                    title="Criação do CFMA"
                    subtitle="2009"
                    side="left"
                >
                </q-timeline-entry>
                <q-timeline-entry
                    title="Assinatura do contracto com a City of Glasgow College"
                    subtitle="2012"
                    side="right"
                >
                </q-timeline-entry>
                <q-timeline-entry
                    title="Abertura do CFMA – Centro de Formação"
                    subtitle="2014"
                    side="left"
                >
                    <div>Marítima – Manuel Augusto Alfredo, Lda</div>
                </q-timeline-entry>
                <q-timeline-entry
                    title="Encerramento das actividades do CFMA"
                    subtitle="2015"
                    side="right"
                >
                    <div>
                        Constituída a Comissão Liquidatária da Sociedade CFMA –
                        Centro de Formação.
                    </div>
                </q-timeline-entry>
                <q-timeline-entry
                    title="Transferência dos colaboradores do CFMA para a Academia Sonangol e Sonangol E.P"
                    subtitle="2016"
                    side="left"
                >
                </q-timeline-entry>
                <q-timeline-entry
                    title="Reabertura das instalações do CFMA para suporte ao Centro de Formação de Cacuaco"
                    subtitle="2019"
                    side="right"
                >
                    <div>Extinção da Comissão Liquidatária do CFMA.</div>
                </q-timeline-entry>
            </q-timeline>
        </div>
    </div>
</template>

<script>
import PageLoading from '@/components/PageLoading'

const loadingKeys = {
    fetchingAbout: 'fetching-about',
}

export default {
    name: 'AboutHistory',

    components: {
        PageLoading,
    },

    data() {
        return {
            history: {
                title: 'História do CFMA',
                subtitle: 'OS LÍDERES SEMPRE OLHAM PARA O FUTURO',
                first_content:
                    '<p>Em 2013, o Conselho de Administração da Sonangol decidiu congregar todas as iniciativas de desenvolvimento do capital humano em uma única entidade, associando desta forma o Centro de Formação Marítima de Angola (CFMA), a Escola de Segurança, a Universidade Corporativa da Sonangol, o processo de Recrutamento e Selecção e a gestão do Programa de Bolsas de Estudo no exterior do país, constituindo desta forma a Academia Sonangol, criando uma forte aproximação com o sector, por meio da combinação das suas aptidões nas diversas áreas educativas associada a experiência dos profissionais da Sonangol, E.P. e suas subsidiárias com vista a elevar os níveis de competência e concomitantemente da qualidade dos serviços prestados.</p><p>Com uma pool de potenciais formadores provenientes dos mais de 9000 colaboradores da Sonangol e um sem número de experts provenientes das instituições renomadas com as quais tem acordos de cooperação, o Centro de Formação Marítima de Angola (CFMA) espera proporcionar aos seus formandos uma larga variedade de experiência técnica e de campo detida pelos seus formadores internos e consultores de reconhecida competências.</p>',
                second_content:
                    '<p>O CFMA conta hoje com uma vasta oferta formativa, porém com o suporte dos seus experts, desenvolve igualmente programas de formação desenhados à medida das reais necessidades dos colaboradores dos seus clientes considerando os objectivos da organização, com programas modulares divididos em 70, 20 e 10, ou seja, programas em sala de aulas, online e no local de trabalho.</p><p>No esteio de desenvolver o capital humano, a sua atenção tem se centrado em Desenvolver Programas Acelerados de Competências Chaves e Críticas alinhadas aos objectivos Estratégicos da SNL, E.P, bem como a cobertura dos gaps de competências com a premissa de redução do tempo para o alcance da autonomia.</p>',
                timeline_title: 'Linha do tempo CFMA',
            },
            firstImage: require('@/assets/images/about-img_1-min.jpg'),
            secondImage: require('@/assets/images/about-img_2-min.jpg'),
        }
    },

    computed: {
        isLoading() {
            return this.isFetchingAbout
        },

        isFetchingAbout() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingAbout
            ).length
        },
    },
}
</script>
